/** Cancel pending tile fetches and drop the current world before opening a new source. */
export function resetViewerBeforeOpen(viewer) {
  if (!viewer) return;

  try {
    if (viewer.imageLoader && typeof viewer.imageLoader.clear === 'function') {
      viewer.imageLoader.clear();
    }
  } catch (err) {
    console.warn('OpenSeadragon imageLoader clear failed:', err);
  }

  try {
    if (typeof viewer.close === 'function') {
      viewer.close();
      return;
    }
  } catch (err) {
    console.warn('OpenSeadragon close failed:', err);
  }

  try {
    viewer.world.removeAll();
  } catch (err) {
    console.warn('OpenSeadragon removeAll failed:', err);
  }
}

/** Stop tile loading on a layer that is being replaced. */
export function resetTiledImageLayer(tiledImage) {
  if (!tiledImage || typeof tiledImage.reset !== 'function') return;
  try {
    tiledImage.reset(false);
  } catch (err) {
    console.warn('OpenSeadragon tiledImage reset failed:', err);
  }
}
